import { useMutation } from '@tanstack/react-query'
import { supabase } from '../../api'

const updatePhone = async (phone: string, userId?: string) => {
  const { data: updateData, error: updateError } = await supabase
    .functions
    .invoke('updatePhone', { body: { phone, userId: userId || '' } })

  if (updateError) {
    throw new Error(updateError.message)
  }

  return updateData
}

export default function useUpdatePhoneWithoutConfirm(phone: string, userId?: string) {
  return useMutation(() => updatePhone(phone, userId), {
    onSuccess: async (data) => data,
  })
}
